var _path, _path2, _path3, _path4, _g, _mask, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCognitive2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#E3147D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.96 153.136L204.346 57.5215C190.799 43.1525 171.591 34.1801 150.285 34.1801C111.159 34.1801 79.0969 64.4291 76.21 102.817C75.9082 106.826 75.0357 110.772 73.4859 114.482L60.6686 145.163C59.1639 148.764 60.1693 152.588 62.6256 155.05L80.6473 172.992V184.972C80.6473 191.454 83.1814 197.343 87.3117 201.706L134.46 248.87V259.751L172.962 298.252C243.899 287.355 298.45 226.76 299.96 153.136Z",
    fill: "url(#paint0_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6678 145.163L73.4852 114.482C75.035 110.772 75.908 106.826 76.2092 102.817C79.0961 64.4291 111.158 34.1801 150.285 34.1801C191.312 34.1801 224.572 67.4396 224.572 108.467C224.572 108.853 224.563 109.237 224.557 109.622C224.555 110.498 224.53 111.38 224.476 112.267C224.475 112.28 224.475 112.293 224.474 112.305C224.463 112.494 224.461 112.681 224.447 112.87L224.406 113.388C224.355 114.159 224.295 114.926 224.222 115.69L209.317 205.72V259.75H134.46V219.909C134.46 214.062 129.721 209.323 123.874 209.323H104.998C91.5491 209.323 80.6471 198.42 80.6471 184.972V157.695H69.0145C62.5557 157.695 58.1788 151.121 60.6678 145.163Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.573 108.468C224.573 108.857 224.562 109.239 224.555 109.621C224.555 110.498 224.531 111.382 224.477 112.266C224.477 112.278 224.477 112.29 224.471 112.308C224.46 112.493 224.46 112.678 224.447 112.869L224.406 113.389C224.358 114.159 224.292 114.929 224.221 115.687L209.316 205.722V259.75H150.147V34.1794H150.285C191.313 34.1794 224.573 67.4396 224.573 108.468Z",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.5 149C176.734 149 198 127.734 198 101.5C198 75.2665 176.734 54 150.5 54C124.266 54 103 75.2665 103 101.5C103 127.734 124.266 149 150.5 149Z",
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 54,
    width: 95,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.912 135.088C135.462 153.638 165.538 153.638 184.088 135.088C202.637 116.538 202.638 86.4625 184.088 67.9125C165.538 49.3626 135.462 49.3626 116.912 67.9125C98.3625 86.4625 98.3625 116.538 116.912 135.088Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.211 97.9645L183.734 60.4878L109.488 134.734L146.964 172.211L221.211 97.9645Z",
    fill: "#E3147D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.786 38.5406L154.035 30.7893L79.7889 105.036L87.5402 112.787L161.786 38.5406Z",
    fill: "#E3147D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.584 53.3385L168.833 45.5872L94.5868 119.833L102.338 127.585L176.584 53.3385Z",
    fill: "#E3147D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 83,
    y: 40,
    width: 135,
    height: 135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 179.96,
    y1: 34.1801,
    x2: 179.96,
    y2: 298.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognitive2);
export default __webpack_public_path__ + "static/media/Cognitive2.e551ec94.svg";
export { ForwardRef as ReactComponent };